import { useContext } from 'react';

import MoveElementModal from '@atom/components/common/moveElement/MoveElementModal';
import ReplaceElementModal from '@atom/components/common/replaceElement/ReplaceElementModal';
import SubItemsContext, {
  SubItemModalType,
} from '@atom/components/common/subItemTree/SubItemsContext';
import { parentOf } from '@atom/components/common/subItemTree/subItemTreeReducer';

import InventoryDetailContext from '../InventoryDetailContext';

type SubItemsMoveReplaceModalsProps = {
  onClose: () => Promise<void>;
};

const SubItemsMoveReplaceModals = ({
  onClose,
}: SubItemsMoveReplaceModalsProps) => {
  const { asset: rootAsset } = useContext(InventoryDetailContext);
  const { tree, activeModal } = useContext(SubItemsContext);

  const modalNode = activeModal?.node;

  if (!modalNode) {
    return null;
  }

  const parentId = parentOf(tree, modalNode.id);
  const parentSchemaId =
    !parentId || parentId === rootAsset.id
      ? rootAsset.schemaId
      : (tree.nodes[parentId]?.schemaId ?? rootAsset.schemaId);

  return (
    <>
      <MoveElementModal
        open={activeModal.type === SubItemModalType.MOVE}
        onClose={onClose}
        elementId={modalNode.id}
        rootAsset={rootAsset}
        parentSchemaId={parentSchemaId}
      />
      <ReplaceElementModal
        open={activeModal.type === SubItemModalType.REPLACE}
        onClose={onClose}
        elementId={modalNode.id}
        rootAsset={rootAsset}
        parentSchemaId={parentSchemaId}
      />
    </>
  );
};

export default SubItemsMoveReplaceModals;
